import { __assign, __extends, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import classNames from 'classnames';
import styled, { css } from 'styled-components';
import FormGroup from '../Form/FormGroup';
import { removeUndefinedProperties } from '../utils/objects';
var PaddingRightStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > label {\n    padding-right: 8px;\n  }\n  > label:last-child {\n    padding-right: 0px;\n  }\n"], ["\n  > label {\n    padding-right: 8px;\n  }\n  > label:last-child {\n    padding-right: 0px;\n  }\n"])));
var FormGroupWrapper = styled(FormGroup)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &.sinoui-radio-group__block > .sinoui-form-control-label {\n    width: 100%;\n  }\n\n  ", ";\n"], ["\n  &.sinoui-radio-group__block > .sinoui-form-control-label {\n    width: 100%;\n  }\n\n  ", ";\n"])), function (props) { return !props.block && PaddingRightStyle; });
/**
 * 单选按钮组组件。如果没有指定value属性或者value属性值为undefined时，RadioGroup组件就处于非受控状态，会自身维护选中状态。
 */
var RadioGroup = /** @class */ (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.isControlled = false;
        _this.onRadioChange = _this.onRadioChange.bind(_this);
        _this.isControlled = typeof props.value !== 'undefined';
        if (!_this.isControlled) {
            _this.state = {
                value: null,
            };
        }
        return _this;
    }
    RadioGroup.prototype.onRadioChange = function (event, checked) {
        if (this.props.readOnly) {
            return;
        }
        if (checked && this.props.onChange) {
            if (!this.isControlled) {
                this.setState({
                    value: event.target.value,
                });
            }
            event.stopPropagation();
            this.props.onChange(event, event.target.value);
        }
    };
    RadioGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, valueProp = _a.value, labelPosition = _a.labelPosition, dense = _a.dense, disabled = _a.disabled, onFocus = _a.onFocus, onBlur = _a.onBlur, color = _a.color, readOnly = _a.readOnly, onChange = _a.onChange, block = _a.block, rest = __rest(_a, ["children", "value", "labelPosition", "dense", "disabled", "onFocus", "onBlur", "color", "readOnly", "onChange", "block"]);
        var value = this.isControlled ? valueProp : this.state.value;
        return (React.createElement(FormGroupWrapper, __assign({}, rest, { className: classNames('sinoui-radio-group', {
                'sinoui-radio-group__block': block,
            }, this.props.className), block: block }), React.Children.map(children, function (radio) {
            if (React.isValidElement(radio)) {
                var radioValue = radio.props.value || radio.props.children;
                var radioProps = removeUndefinedProperties({
                    checked: value === radioValue,
                    onChange: _this.onRadioChange,
                    dense: dense,
                    disabled: radio.props.disabled || disabled,
                    readOnly: readOnly,
                    onBlur: !readOnly && onBlur,
                    onFocus: !readOnly && onFocus,
                    color: color,
                });
                return React.cloneElement(radio, radioProps);
            }
            return radio;
        })));
    };
    return RadioGroup;
}(React.Component));
export default RadioGroup;
var templateObject_1, templateObject_2;
//# sourceMappingURL=RadioGroup.js.map